import { createElement, forwardRef, useState } from 'react';
import { Radio as Radio$1, FormControl, FormLabel, Stack, RadioGroup as RadioGroup$1, Text, FormErrorMessage, HStack, VStack } from '@chakra-ui/react';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["children"],
    _excluded2 = ["children", "error", "label", "isInvalid", "inline", "options", "direction", "isDisabled", "labelProps", "optionsProps", "onChange", "isResetable", "defaultValue", "alignItems"];

var Radio = function Radio(props) {
  var children = props.children,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  return createElement(Radio$1, Object.assign({}, rest), children);
};

var RadioGroup = /*#__PURE__*/forwardRef(function (props, ref) {
  var error = props.error,
      label = props.label,
      isInvalid = props.isInvalid,
      inline = props.inline,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      direction = props.direction,
      isDisabled = props.isDisabled,
      labelProps = props.labelProps,
      optionsProps = props.optionsProps,
      onChange = props.onChange,
      isResetable = props.isResetable,
      defaultValue = props.defaultValue,
      alignItems = props.alignItems,
      rest = _objectWithoutPropertiesLoose(props, _excluded2);

  var Wrapper = inline ? HStack : VStack;

  var _React$useState = useState(defaultValue || ''),
      val = _React$useState[0],
      setVal = _React$useState[1];

  var handleChange = function handleChange(value) {
    onChange == null ? void 0 : onChange(value);
    setVal(value);
  };

  var handleReset = function handleReset(e) {
    if (isResetable) {
      e.preventDefault();
      setVal('');
      onChange == null ? void 0 : onChange(null);
    }
  };

  return createElement(FormControl, {
    isInvalid: isInvalid || !!error,
    w: "full"
  }, createElement(Wrapper, {
    alignItems: "normal",
    w: "full"
  }, label && createElement(FormLabel, Object.assign({
    mb: inline ? '0' : '2',
    whiteSpace: "nowrap"
  }, labelProps), label), createElement(Stack, {
    alignItems: alignItems || 'flex-start',
    w: "full"
  }, createElement(RadioGroup$1, Object.assign({
    isDisabled: isDisabled,
    onChange: handleChange,
    value: val
  }, rest, {
    ref: ref
  }), createElement(Stack, {
    direction: direction || 'row'
  }, options.map(function (_ref) {
    var label = _ref.label,
        value = _ref.value,
        color = _ref.color;
    return createElement(Radio, Object.assign({
      key: value,
      value: value,
      colorScheme: color,
      onClick: function onClick(e) {
        return val === value ? handleReset(e) : {};
      },
      isChecked: value === val
    }, optionsProps), createElement(Text, Object.assign({}, optionsProps), label));
  }))), createElement(FormErrorMessage, null, error))));
});
export default Radio;
export { RadioGroup };